import { IScene } from '@/helpers/editor';
import { Component, Mixins } from 'vue-property-decorator';
import ProjectMixin from './ProjectMixins';

@Component({})
export default class Project extends Mixins(ProjectMixin) {
  get hasFourOrMoreScene(): boolean {
    return this.project?.scenes?.length > 4;
  }

  get scenePreviews(): IScene[] {
    if (!this.project?.scenes) return [];
    if (this.hasFourOrMoreScene) return this.project?.scenes.slice(0, 3);

    return this.project.scenes.slice(0, 4);
  }

  get additionalSceneCount(): number {
    if (this.hasFourOrMoreScene) return this.project?.scenes?.length - 3;

    return 0;
  }
}
